export default "/assets/provider-badge-automait.v1.svg";